
const DEFAULT_EASING = "None";

function ReflowTimelineControlDelegate($scope, $el, $interval, $rootScope) {
	this.$scope = $scope;
	this.$el = $el;
	this.$interval = $interval;
	this.$rootScope = $rootScope;
	this.isBuilt = false;
	this.isDraggingMarker = false;
	this.playing = false;
}

ReflowTimelineControlDelegate.prototype.build = function() {

	if(!this.isBuilt) {
		this.isBuilt = true;
		this.drawGraticule();
		this.setupTimelineMarker();
		this.handleTimeEditor();
	}

};

ReflowTimelineControlDelegate.prototype.showTimeEditor = function() {
	
	var self = this;
	
	$(".current-time-editor", this.$el).val(self.$scope.timeline.time);
	$(".current-time", this.$el).hide();
	$(".current-time-editor", this.$el).show();
	$(".current-time-editor", this.$el).focus();
	
};

ReflowTimelineControlDelegate.prototype.handleTimeEditor = function() {
	
	var self = this;
	
	$(".current-time-editor", this.$el).blur(function(ev) {
		$(".current-time-editor", this.$el).val(self.$scope.timeline.time);
		$(".current-time", this.$el).show();
		$(".current-time-editor", this.$el).hide();
	});
	
	$(".current-time-editor", this.$el).keydown(function(ev) {
		var time = parseFloat($(".current-time-editor", this.$el).val());
		switch(ev.which) {
		case 9:
			// tab
			self.$scope.timeline.time = time;
			self.$scope.$apply();
			$(".current-time", this.$el).show();
			$(".current-time-editor", this.$el).hide();
			break;
		case 13:
			// enter
			self.$scope.timeline.time = time;
			self.$scope.$apply();
			$(".current-time", this.$el).show();
			$(".current-time-editor", this.$el).hide();
			break;
		case 27:
			// esc
			$(".current-time", this.$el).show();
			$(".current-time-editor", this.$el).hide();
			break;
		}
	});
	
};

ReflowTimelineControlDelegate.prototype.updateTime = function() {
	
	var self = this;
	
	var offset = this.$scope.timeline.time * self.$scope.scale;
	var scrollLeft = $(".timeline-right-pane-inner", this.$el).position().left - 250;
	var width = $(".timeline-right-pane", this.$el).width();
	
	$(".timeline-ruler", this.$el).css("left", offset);
	
	if(!this.isDraggingMarker) {		
		$(".timeline-marker", this.$el).css({left: offset});
		if(offset + scrollLeft > width - 2 * self.$scope.scale) {
			var newLeft = -offset + width - 2 * self.$scope.scale;
			$(".timeline-right-pane-inner", this.$el).css("left", newLeft);
		}
		else if(offset + scrollLeft < 0) {
			var newLeft = -offset;
			$(".timeline-right-pane-inner", this.$el).css("left", newLeft);
		}
	}
		
	this.$scope.currentTimeFormatted = moment(0).add("seconds", this.$scope.timeline.time).format("mm:ss.SSS");	
	$(".current-time-editor", this.$el).val(this.$scope.timeline.time);

	if(!!this.gs && !this.gs.isActive()) {

		if(this.gs.totalDuration() === this.gs.time()) {
			this.gs.pause();
			this.$scope.timeline.state = "paused";
		}

		this.gs.seek(this.$scope.timeline.time);
	}

};

ReflowTimelineControlDelegate.prototype.drawGraticule = function() {
		
	var self = this;
	
	let duration = Math.max(this.$scope.timeline.totalDuration, 31);

	$(".timeline-right-pane-inner", this.$el).width((duration + 2) * self.$scope.scale);
	$(".timeline-graticule", this.$el).width((duration + 2) * self.$scope.scale);
		
	$(".timeline-graticule", this.$el).empty();
	var g = $(".timeline-graticule", this.$el).get(0);
	
	var s = Snap(g);
	var t = 0;
	var l1;
	
	for(var i = 0; i <= (duration + 1) * self.$scope.scale; i += (self.$scope.scale / 10)) {
	
		var x = i;
		if(i % self.$scope.scale == 0) {	
			l1 = s.line(x, 0, x, 25);
		}
		else if(i % (self.$scope.scale / 2) == 0) {	
			l1 = s.line(x, 0, x, 10);
		}
		else {
			l1 = s.line(x, 0, x, 5);
		}
		
		l1.attr({
			fill:"#000000",
			stroke:"#000000",
			strokeWidth:1 			
		});
		
		if(i % self.$scope.scale == 0) {
			s.text(x + 2, 15, t.toFixed(0)).attr({"font-family": "Open Sans", "font-size": "8pt", "fill": "#000000", "stroke": "#000000"});
		}
		
		t += 0.1;

	}
	
	l1 = s.line(0, 0, i, 0);
	l1.attr({
		fill:"#000000",
		stroke:"#000000",
		strokeWidth:1 			
	});	
	
	// g = $(".timeline-ruler", this.$el).get(0);
	// s = Snap(g).attr({viewBox:"0 0 15 1000"});
	// l1 = s.line(7, -1000, 7, 3000);
	// l1.attr({
	// 	fill:"#000000",
	// 	stroke:"#000000",
	// 	strokeWidth:1 			
	// });

	$(".timeline-graticule", this.$el).click(function(ev, ui) {
		if(ev.target.nodeName != "text") {
			var time = (ev.offsetX - 5) / self.$scope.scale;
		}
		else {
			var time = ($(ev.target).offset().left - $(".timeline-graticule").offset().left + ev.offsetX) / self.$scope.scale;
		}
		self.$scope.timeline.time = time;
		self.$scope.$apply();
	});

};

ReflowTimelineControlDelegate.prototype.setupTimelineMarker = function() {
	
	var self = this;

	$(".timeline-marker", this.$el).draggable({
		axis: "x",
		containment: "parent",
		cursor: "ew-resize",
		snap: ".snappable",
		grid: [ 5, 0],
		start: function(ev, ui) {
			self.isDraggingMarker = true;
			self.$scope.timeline.state = "paused";
			self.$scope.$apply();
		},
		drag: function(ev, ui) {
			
			var time = ui.position.left / self.$scope.scale;
			self.$scope.timeline.time = time;
			self.$scope.$apply();
			
		},
		stop: function(ev, ui) {
			
			var time = ui.position.left / self.$scope.scale;
			self.$scope.timeline.time = time;
			
			self.isDraggingMarker = false;
			self.$scope.$apply();

		}
	});
	
};

ReflowTimelineControlDelegate.prototype.play = function() {
	if(this.$scope.timeline.time == this.$scope.timeline.totalDuration) {
		this.$scope.timeline.time = 0;
		this.gs.restart();
	}
	this.$scope.timeline.state = "playing";
	if(!!this.gs) {
		this.gs.play();
	}
};

ReflowTimelineControlDelegate.prototype.pause = function() {
	this.$scope.timeline.state = "paused";
	if(!!this.gs) {
		this.gs.pause();
	}
};

ReflowTimelineControlDelegate.prototype.first = function() {
	this.pause();
	this.$scope.timeline.time = 0;
	if(!!this.gs) {
		this.gs.seek(this.$scope.timeline.time);
	}
};

ReflowTimelineControlDelegate.prototype.back = function() {
	
	var self = this;
	
	self.pause();
	
	if(self.$scope.canvas.keyframeMarkers.length > 0) {
		
		var ix = self.$scope.canvas.keyframeMarkers.length - 1;
		while(ix >= 0  && self.$scope.canvas.keyframeMarkers[ix] >= self.$scope.timeline.time) {
			ix--;
		}
		
		if(ix < 0) {
			self.$scope.timeline.time = 0;
		}
		else {
			self.$scope.timeline.time = self.$scope.canvas.keyframeMarkers[ix];
		}
		
	}
	else {
		self.$scope.timeline.time = 0;
	}

	if(!!this.gs) {
		this.gs.seek(this.$scope.timeline.time);
	}	
};

ReflowTimelineControlDelegate.prototype.next = function() {
	
	var self = this;
	
	self.pause();
	
	if(self.$scope.canvas.keyframeMarkers.length > 0) {
		
		var ix = 0;
		while(ix < self.$scope.canvas.keyframeMarkers.length && self.$scope.canvas.keyframeMarkers[ix] <= self.$scope.timeline.time) {
			ix++;
		}
		
		if(ix < self.$scope.canvas.keyframeMarkers.length) {
			self.$scope.timeline.time = self.$scope.canvas.keyframeMarkers[ix];
		}
		
	}
	else if("undefined" !== typeof self.$scope.timeline.totalDuration) {
		self.$scope.timeline.time = self.$scope.timeline.totalDuration;
	}
	
	if(!!this.gs) {
		this.gs.seek(this.$scope.timeline.time);
	}

};

ReflowTimelineControlDelegate.prototype.last = function() {
	
	var self = this;
	
	self.pause();
	
	if("undefined" !== typeof self.$scope.timeline.totalDuration) {
		self.$scope.timeline.time = self.$scope.timeline.totalDuration;
	}
	
	if(!!this.gs) {
		this.gs.seek(this.$scope.timeline.time);
	}

};

ReflowTimelineControlDelegate.prototype.startAnimations = function() {
		
};

ReflowTimelineControlDelegate.prototype.deleteAnims = function (anims, parent) {
    'use strict';
    var self = this;
    anims.forEach(function (anim) {
        self.deleteAnim(anim, parent);
    });
};

ReflowTimelineControlDelegate.prototype.deleteAnim = function(anim, parent) {
	
	if("undefined" !== typeof parent) {
		var ix = parent.animations.indexOf(anim);
	}
	else {
		var ix = this.$scope.timeline.animations.indexOf(anim);
	}
	
	if(ix >= 0) {
		if("undefined" !== typeof parent) {
			parent.animations.splice(ix, 1);
		}
		else {
			this.$scope.timeline.animations.splice(ix, 1);
		}
	}
};

ReflowTimelineControlDelegate.prototype.copyAnim = function(anim, parent) {
	
	var newAnim = JSON.parse(JSON.stringify(anim));
	newAnim.id = ObjectId();
	newAnim.layerId = null;
	
	if("undefined" !== typeof parent) {
		parent.animations.push(newAnim);
	}
	else {
		this.$scope.timeline.animations.push(newAnim);
	}

};

ReflowTimelineControlDelegate.prototype.calcHeight = function() {
	
	var self = this;
	
	if(self.$scope.canvas == null) {
		return;
	}
	
	self.$scope.calcHeight = 100;
	$(".timeline-left-pane > .timeline-row", this.$el).each(function() {
		self.$scope.calcHeight += $(this).height();
	});
	
};

ReflowTimelineControlDelegate.prototype.select = function(selected) {
	if(selected) {
		this.buildAnimation();
	}
	else {
		this.$scope.timeline.animations.forEach((anim) => { anim.selected = false; });
		this.disposeAnimation();
		this.$rootScope.$emit("deselect-timeline", this.$scope.timeline);
	}
};

ReflowTimelineControlDelegate.prototype.buildAnimation = function(selected) {

	this.disposeAnimation();

	this.gs = new TimelineMax({
		paused: true,
		onUpdate: () => {
			this.$scope.timeline.state = "playing";
			this.$scope.timeline.time = this.gs.time();
			this.updateTime();
		},
		onComplete: () => {
			this.$scope.timeline.state = "paused";
		}
	});

	$.each(this.$scope.canvas.layers, (ix, layer) => {
		this.gs.set($("#layer-" + layer.id), { left: layer.left }, 0);
	});

	$.each(this.$scope.timeline.animations, (ix, anim) => {
		if(anim.layerId != null) {

			let props = {};
			
			$.each(anim.props, (k, v) => {
				if(("" + v).length > 0) {
					props[k] = !isNaN(v) ? parseFloat(v) : v.toString();
				}
			});
						
			if("undefined" !== typeof anim.props.visible) {
				props.visibility = anim.props.visible ? "visible" : "hidden";
				delete props.visible;
			}
			
			let easeFn = this.$scope.easings[anim.easing] || this.$scope.easings[DEFAULT_EASING];
			if(!!easeFn) {
				props.ease = easeFn;
			}

			props.data = anim;
			this.gs.to("#layer-" + anim.layerId, anim.duration, props, anim.pos);
			
		}
	});

	this.gs.seek(this.$scope.timeline.time);
	this.$scope.timeline.totalDuration = this.gs.duration();
};

ReflowTimelineControlDelegate.prototype.disposeAnimation = function(selected) {
	if(!!this.gs) {
		this.gs.seek(0);
		this.gs.kill();
		delete this.gs;
	}
};


var reflowTimelineControl = angular.module('cpm').directive("reflowTimelineControl", ["$interval", "$timeout", "$rootScope", function($interval, $timeout, $rootScope) {
	return {
		restrict: "E",
		templateUrl: "builder/reflow-timeline-control.html",
		scope: {
			adunit: "=",
			canvas: "=",
			timeline: "=",
		},
		link: function($scope, $el, $attributes) {
			
			$scope.scale = 50;	        
			$scope.currentTimeFormatted = "00:00.00";
			$scope.expandedAnims = [];

			function isCanvasLocked() {
				return typeof $scope.canvas.locked != "undefined" && $scope.canvas.locked;
			}
			
			$(".timeline-rows-outer", $el).sortable({
				items: "> .timeline-row",
				stop: (ev,ui) => {

                    let animOrder = [];
                    
                    $(".timeline-rows-outer > .timeline-row", $el).each( (ix, el) => {
                        let animId = $(el).attr("data-anim-id");
                        let anim = $scope.timeline.animations.find(x => x.id == animId);
                        if(!!anim) {
                            animOrder.push(anim);
                        }
                    });

                    $scope.timeline.animations.splice(0);
                    animOrder.forEach( (anim) => {
                        $scope.timeline.animations.push(anim);
                    });

					$scope.$apply();
				}
			});

			$scope.easings = {
				"None": Power0.easeNone,
				"Power1 In": Power1.easeIn,
				"Power1 Out": Power1.easeOut,
				"Power1 InOut": Power1.easeInOut,
				"Power2 (In)": Power2.easeIn,
				"Power2 (Out)": Power2.easeOut,
				"Power2 (In/Out)": Power2.easeInOut,
				"Power3 (In)": Power3.easeIn,
				"Power3 (Out)": Power3.easeOut,
				"Power3 (In/Out)": Power3.easeInOut,
				"Power4 (In)": Power4.easeIn,
				"Power4 (Out)": Power4.easeOut,
				"Power4 (In/Out)": Power4.easeInOut,
				"Back (In)": Back.easeIn,
				"Back (Out)": Back.easeOut,
				"Back (In/Out)": Back.easeInOut,
				"Elastic In": Elastic.easeIn.config(1, 0.3),
				"Elastic Out": Elastic.easeOut.config(1, 0.3),
				"Elastic InOut": Elastic.easeInOut.config(1, 0.3)
			};

			if($scope.canvas != null) {
				$scope.timeline.totalDuration = $scope.canvas.duration || 31;
			}
			else {
				$scope.timeline.totalDuration = 31;
			}
			
			if("undefined" === typeof $scope.timeline.time)	{
				$scope.timeline.time = 0;
			}
			
			if("undefined" === typeof $scope.timeline.state)	{
				$scope.timeline.state = "paused";
			}
			
			$scope.expandedAnims = {};
			$scope.calcHeight = 75;
			
			var delegate = new ReflowTimelineControlDelegate($scope, $el, $interval, $rootScope);			
			delegate.build();
			
			$scope.$watch("timeline.time", function(newitem, olditem) {
				delegate.updateTime();
			});

			$scope.$watch("timeline.animations", function(newitem, olditem) {
				delegate.buildAnimation();
			}, true);
			
			$rootScope.$on("select-timeline", (ev, args) => {
				if(args.timeline.id === $scope.timeline.id) {
					$el.closest("ad-tool-window").trigger("select-toolwindow");
				}				
			});
			
			$scope.$on("seekTime", function(ev, time) {
				$scope.timeline.time = time.time;
			});

			$scope.$on("showTimelineRuler", function(ev, show) {
				if(show) {
					$(".timeline-ruler").css("visibility", "visible");
				}
				else {
					$(".timeline-ruler").css("visibility", "hidden");
				}
			});
		
			$scope.$on("selectLayerId", function(ev, layerId) {
				var layer = $scope.canvas.layers.find(function(x) { return x.id == layerId; });
				if("undefined" !== typeof layer) {
					$scope.currentLayer = layer;
				}
			});

			
			$scope.$watch("timeline.totalDuration", function() {
				delegate.drawGraticule();
			});
			
			$scope.selectLayer = function(layer) {
				$scope.currentLayer = layer;
			};
			
			$scope.selectAnim = function(anim) {
				if(anim.layerId) {
					$scope.currentAnim = anim;
				}
			};
			
			$scope.addMarker = function() {
				if($scope.timeline.keyframeMarkers.indexOf($scope.timeline.time) < 0) {
					$scope.timeline.keyframeMarkers.push($scope.timeline.time);
					$scope.timeline.keyframeMarkers.sort();
				}				
			};
			
			$scope.zoomIn = function() {
				if($scope.scale < 200) {
					$scope.scale = $scope.scale * 2;					
					delegate.drawGraticule();
					delegate.updateTime();
				}
			};
			
			$scope.zoomOut = function() {
				if($scope.scale > 50) {
					$scope.scale = $scope.scale / 2;
					var newTime = Math.floor($scope.timeline.time * $scope.scale);
					newTime = (newTime - (newTime % 5)) / $scope.scale;
					$scope.timeline.time = newTime;
					delegate.drawGraticule();
					delegate.updateTime();
				}
			};
			
			$scope.first = function() {
				delegate.first();
			};
			
			$scope.back = function() {
				delegate.back();
			};

			$scope.play = function() {
				delegate.play();
			};

			$scope.pause = function() {
				delegate.pause();
			};

			$scope.next = function() {
				delegate.next();
			};

			$scope.last = function() {
				delegate.last();
			};
			
			$scope.showTimeEditor = function() {
				delegate.showTimeEditor();
			};
			
			$scope.copyAnim = function(anim, parent) {
				if(!isCanvasLocked()) {
					delegate.copyAnim(anim, parent);
				}
			};
			
			$scope.deleteAnim = function(anim, parent) {
				if(!isCanvasLocked()) {
					delegate.deleteAnim(anim, parent);
				}
			};
			
			$scope.toggleAnim = function(anim) {
				if($scope.expandedAnims[anim.id]) {
					$scope.expandedAnims[anim.id] = !$scope.expandedAnims[anim.id];
				}
				else {
					$scope.expandedAnims[anim.id] = true;
				}
				$timeout(function() {
					delegate.calcHeight();
				}, 400);								
			};
			
			$scope.addNewAnim = function() {
				if(!isCanvasLocked()) {
					let anim = {
						id: ObjectId(),
						layerId: null,
						pos: 0,
						duration: 2,
						animations: [ ],
						props: {},
						easing: DEFAULT_EASING
					};
					$scope.timeline.animations.push(anim);
					$scope.timeline.time = anim.pos + anim.duration;
				}
			};

			$scope.showScrollTriggerConfig = function(timeline) {
				$rootScope.$emit("show-scroll-trigger-config", timeline);
			};
			
			$scope.addNewSubAnim = function(anim) {
				if(!isCanvasLocked()) {
					anim.animations.push({
						id: ObjectId(),
						layerId: $scope.currentLayer.id,
						pos: 0,
						duration: 2,
						props: {},
						easing: DEFAULT_EASING
					});
					$scope.expandedAnims[anim.id] = true;
				}
			};
			
			$scope.removeMarker = function(marker) {
				var ix = $scope.timeline.keyframeMarkers.indexOf(marker);
				if(ix >= 0) {
					$scope.timeline.keyframeMarkers.splice(ix, 1);
				}
			};

			$scope.onShow = function() {
				$(".timeline-rows-outer", $el).sortable( "disable");
			};

			$scope.onHide = function() {
				$(".timeline-rows-outer", $el).sortable( "enable");
			}

			$scope.$on('rebuildAnims', () => {
				delegate.buildAnimation();
			})

            $scope.$on('deleteLayer', function (event, args) {
                delegate.deleteAnims(args.anims, args.parent);
            });

            $el.closest("ad-tool-window").on("selected", (ev, selected) => {
            	delegate.select(selected);
            });

            $el.closest("ad-tool-window").on("close", () => {
            	delegate.select(false);
            });

		}
	};
	
}]);

var timelineDropTarget = angular.module('cpm').directive("timelineDropTarget", function() {
	return {
		restrict: "A",		
		scope: {
			layer: "=timelineDropTarget",
			prop: "@"
		},
		link: function($scope, $el, $attributes) {
			
			$el.droppable({ 
				accept: function(tgt) {
					if($(tgt).hasClass("addanim")) {
						return true;
					}
					else {
						return false;
					}
				}, 
				drop: function(ev, ui) {
					
					var droppedPos = ui.offset; 
					var thisPos = $(this).offset();

					var time = (droppedPos.left - thisPos.left - 3) / 50;
					
					var anim = {
						pos: time,
						duration: 2,
						props: {},						
					};
					
					if("undefined" != typeof $scope.prop) {
						anim.restrict = $scope.prop;
					}
					
					$scope.layer.anims.push(anim);
					$scope.$apply();
				} 
			});
			
		}
	};
});

var timelinePropMarker = angular.module('cpm').directive("timelinePropMarker", ["$rootScope", function($rootScope) {
	return {
		restrict: "A",
		template: "<div class='anim_pos'></div><div class='anim_duration'></div><div class='duration_drag'></div>",
		scope: {
			timeline: "=",
			anim: "=timelinePropMarker",
			parent: "=",
			scale: "=",
			prop: "@",
			canvas: "="
		},
		link: function($scope, $el, $attributes) {

			function disableOrEnableDraggables() {
				if(isCanvasLocked()) {
					$el.draggable("disable");
					$(".duration_drag", $el).draggable("disable");
				}
				else {
					$el.draggable("enable");
					$(".duration_drag", $el).draggable("enable");
				}
			}

			function isCanvasLocked() {
				return typeof $scope.canvas.locked != "undefined" && $scope.canvas.locked;
			}
			
			function layout() {
				
				$scope.layer = $scope.canvas.layers.find(function(x) { return x.id == $scope.anim.layerId; });

				if("undefined" !== typeof $scope.layer) {
					var bkg = $scope.layer.builderColour;
				}
				else {
					var bkg = "#d06dd9";
				}
				
				var startPos = $scope.anim.pos;
				if("undefined" !== typeof $scope.parent) {
					startPos += $scope.parent.pos;
				}
				
				var width = Math.max($scope.anim.duration * $scope.scale, 10);
				
				if("undefined" === typeof $scope.prop) {
					$el.css({
						left: startPos * $scope.scale + 6,
						width: width,
						display: "block",
						"background-color": bkg
					});
				}
				else {
					if("undefined" !== typeof $scope.anim.props[$scope.prop]) {
						$el.css({
							left: startPos * $scope.scale + 6,
							width: width,
							display: "block",
							"background-color": bkg
						});
					}
					else {
						$el.css("display", "none");
					}
				}
			}
			
			function calculateTimings(ui) {
				
				var time = (ui.position.left - 6) / $scope.scale;
				
				if("undefined" !== typeof $scope.parent) {					
					$scope.anim.pos = time - $scope.parent.pos;
				}
				else {
					$scope.anim.pos = time;
				}
				
				$scope.$emit("seekTime", { time: time, anim: $scope.anim });
				
			}
			
			function fixParent() {
				if("undefined" !== typeof $scope.parent) {
					
					var minPos = 99999;
					var maxEnd = 0;
					
					$.each($scope.parent.animations, function(ix, sub) {
						if(sub.pos < minPos) {
							minPos = sub.pos;
						}
						if(sub.pos + $scope.parent.pos + sub.duration > maxEnd) {
							maxEnd = sub.pos + $scope.parent.pos + sub.duration;
						}						
					});
					
					$scope.parent.pos = $scope.parent.pos + minPos;
					$scope.parent.duration = maxEnd - $scope.parent.pos;
					$.each($scope.parent.animations, function(ix, sub) {
						sub.pos -= minPos;
					});

				}
			}

			$scope.$watch('canvas', (newVal) => {
				disableOrEnableDraggables();
			}, true);
			
			$scope.$watch("anim", function() {
				if("undefined" !== typeof $scope.anim) {
					layout();
				}
			}, true);
			
			$scope.$watch("parent", function() {
				if("undefined" !== typeof $scope.parent) {
					layout();
				}
			}, true);
			
			$scope.$watch("scale", function() {
				layout();
			});
						
			$scope.$watch("anim.props", function(newval, oldval) {
				if("undefined" !== typeof $scope.anim && "undefined" !== typeof newval && "undefined" !== typeof oldval && (JSON.stringify(newval) !== JSON.stringify(oldval))) {
					if("undefined" !== typeof $scope.parent) {					
						$scope.timeline.time = $scope.anim.pos + $scope.parent.pos + $scope.anim.duration;
					}
					else {
						$scope.timeline.time = $scope.anim.pos + $scope.anim.duration;
					}
				}
			}, true);
			
			$scope.$watch("anim.layerId", function(layerId) {
				if(layerId != null) {
					$rootScope.$emit("select-anim", { anim: $scope.anim, canvas: $scope.canvas });
				}
			});

			$scope.$watch("layer.builderColour", function() {
				layout();
			});

			$scope.$watch('layer', (newVal, oldVal) => {
				if(!!newVal && (oldVal.height != newVal.height || oldVal.width != newVal.width || oldVal.left != newVal.left || oldVal.top != newVal.top)) {
					$scope.timeline.time = 0;
					$('#layer-' + newVal.id).css({'top': newVal.top, 'left': newVal.left, "height" : newVal.height, "width": newVal.width});
					$scope.$emit('rebuildAnims');
				}
			}, true);

			$rootScope.$on("select-anim", (ev, args) => {
				$scope.layer = $scope.canvas.layers.find(function(x) { return x.id == $scope.anim.layerId; }); 
				if(args.anim.id == $scope.anim.id) {
					$el.addClass("selected");
					$scope.anim.selected = true;
				}
				else {
					$el.removeClass("selected");
					$scope.anim.selected = false;
				}
			});

			$el.click(function() {
				if("undefined" !== typeof $scope.parent) {
					$scope.$emit("seekTime", { time: $scope.anim.pos + $scope.anim.duration + $scope.parent.pos });
				}
				else {
					$scope.$emit("seekTime", { time: $scope.anim.pos });
				}
				$rootScope.$emit("select-anim", { anim: $scope.anim, canvas: $scope.canvas });
				$scope.$apply();
			});
			
			$el.draggable({
				cursor: "ew-resize",
				axis: "x",
				handle: ".anim_duration",
				snap: ".snappable",
				snapMode: "inner",
				snapTolerance: 10,
				grid: [5, 0],
				start: function(ev, ui) {
					
				},
				drag: function(ev, ui) {
					calculateTimings(ui);
					$scope.$apply();
				},
				stop: function(ev, ui) {
					calculateTimings(ui);
					fixParent();
					$scope.$apply();
				}
			});
			
			$(".duration_drag", $el).draggable({
				cursor: "e-resize",
				axis: "x",
				snap: ".snappable",
				snapMode: "inner",
				snapTolerance: 10,
				grid: [5, 0],
				start: function(ev, ui) {
					
				},
				drag: function(ev, ui) {
					
					var newWidth = ui.position.left + 5;
					$el.css("width", newWidth);
					var time = (newWidth - 1) / $scope.scale;
					
					if("undefined" !== typeof $scope.parent) {
						$scope.$emit("seekTime", { time: $scope.parent.pos + $scope.anim.pos + time, anim: $scope.anim });
					}
					else {
						$scope.$emit("seekTime", { time: $scope.anim.pos + time, anim: $scope.anim });
					}
					
					$scope.$apply();
					
				},
				stop: function(ev, ui) {
					
					$(".duration_drag", $el).css("left", "auto");
					$(".duration_drag", $el).css("right", 0);
					
					var duration = (ui.position.left + 4) / $scope.scale;
					
					$scope.anim.duration = duration;
					
					fixParent();
										
					
					if("undefined" !== typeof $scope.parent) {
						$scope.$emit("seekTime", { time: $scope.parent.pos + $scope.anim.pos + $scope.anim.duration, anim: $scope.anim });
					}
					else {
						$scope.$emit("seekTime", { time: $scope.anim.pos + $scope.anim.duration, anim: $scope.anim });
					}

					$scope.$apply();					
				}
			});
			
		}
		
	};	
}]);

var keyframeMarker = angular.module('cpm').directive("keyframeMarker", function() {
	return {
		restrict: "E",
		template: "<span class='glyphicon glyphicon-triangle-bottom' aria-hidden='true' style='color: red'></span>",
		scope: {
			pos: "@",
			scale: "="
		},
		link: function($scope, $el, $attributes) {
			
			//$el.css("left", ($scope.pos * $scope.scale) + "px");
			
			$scope.$watch("scale", function() {
				if("undefined" !== typeof $scope.scale) {
					$el.css("left", ($scope.pos * $scope.scale) + "px");
				}
			});
			
		}
	};
});

var animProps = angular.module('cpm').directive("animProps", function() {
	return {
		restrict: "E",
		templateUrl: "builder/anim-props.html",
		scope: {
			anim: "=",
			canvas: "="
		},
		link: function($scope, $el, $attributes) {
			
			$scope.proplist = [
   			    { label: "Top", prop: "top" },
   			    { label: "Left", prop: "left" },
   			    { label: "Width", prop: "width" },
   			    { label: "Height", prop: "height" },
   			    { label: "Opacity", prop: "opacity" },
   			    { label: "Visibility", prop: "visibility" },
   			    { label: "Rotation X", prop: "rotationX" },
   			    { label: "Rotation Y", prop: "rotationY" },
   			    { label: "Rotation Z", prop: "rotationZ" },
   			    { label: "Scale X", prop: "scaleX" },
   			    { label: "Scale Y", prop: "scaleY" },
   			    { label: "Skew X", prop: "skewX" },
   			    { label: "Skew Y", prop: "skewY" }
   			];
   			
			// See reflowTimelineControl's $scope.easings (CS-6297) - values must stay live
			// GSAP function references, never strings.
			$scope.easings = {
				"None": Power0.easeNone,
				"Power1 In": Power1.easeIn,
				"Power1 Out": Power1.easeOut,
				"Power1 InOut": Power1.easeInOut,
				"Power2 (In)": Power2.easeIn,
				"Power2 (Out)": Power2.easeOut,
				"Power2 (In/Out)": Power2.easeInOut,
				"Power3 (In)": Power3.easeIn,
				"Power3 (Out)": Power3.easeOut,
				"Power3 (In/Out)": Power3.easeInOut,
				"Power4 (In)": Power4.easeIn,
				"Power4 (Out)": Power4.easeOut,
				"Power4 (In/Out)": Power4.easeInOut,
				"Back (In)": Back.easeIn,
				"Back (Out)": Back.easeOut,
				"Back (In/Out)": Back.easeInOut,
				"Elastic In": Elastic.easeIn.config(1, 0.3),
				"Elastic Out": Elastic.easeOut.config(1, 0.3),
				"Elastic InOut": Elastic.easeInOut.config(1, 0.3)
			};
			
			$scope.layer = $scope.canvas.layers.find(function(x) { return x.id == $scope.anim.layerId; });

   			$el.mouseover(function() {
   				$scope.$emit("showTimelineRuler", false);
   			});
   			
   			$el.mouseout(function() {
   				$scope.$emit("showTimelineRuler", true);
   			});
   			
   			$scope.$watch("anim.pos", function(newval) {
				$scope.anim.pos = Math.max(0, newval);
   			});
   			
   			$scope.$watch("anim.duration", function(newval) {
				$scope.anim.duration = Math.max(0, newval);
   			});
   			
   			$scope.$watch("anim.layerId", function(newval) {
				$scope.layer = $scope.canvas.layers.find(function(x) { return x.id == $scope.anim.layerId; });
   			})
   			
			$scope.$watch("anim.props.width", function(newval, oldval) {

				if(!$scope.layer) {
					return;
				}

				let aspectRatio = $scope.layer.maintainAspectRatio;

				if("undefined" == typeof $scope.layer || $scope.layer == null) {
					return;
				}
				if("undefined" == typeof aspectRatio) {
					aspectRatio = $scope.layer.width / $scope.layer.height;
				}
				if("undefined" !== typeof newval && "undefined" !== typeof oldval && newval != oldval && parseInt($scope.anim.props.width)) {
					if($scope.layer.maintainAspectRatio) {					
						$scope.anim.props.height = Math.round(($scope.anim.props.width / aspectRatio));
					}
					else {
						aspectRatio = parseInt($scope.anim.props.width) / parseInt($scope.anim.props.height);
					}
				}
			});
						
			$scope.$watch("anim.props.height", function(newval, oldval) {

				if(!$scope.layer) {
					return;
				}
				
				let aspectRatio = $scope.layer.maintainAspectRatio;

				if("undefined" === typeof $scope.layer) {
					return;
				}
				if("undefined" == typeof aspectRatio) {
					aspectRatio = $scope.layer.width / $scope.layer.height;
				}
				if("undefined" !== typeof newval && "undefined" !== typeof oldval && newval != oldval && parseInt($scope.anim.props.height)) {
					if($scope.layer.maintainAspectRatio) {
						$scope.anim.props.width = Math.round($scope.anim.props.height * aspectRatio);
					}
					else {
						aspectRatio = $scope.anim.props.width / parseInt($scope.anim.props.height);
					}
				}
			});
   			
   			
		}
	};
});



class ReflowTimelineScroller {

	constructor() {

		let _self = this;

		return {
			restrict: "E",
			template: "<div class='timeline-scroller'></div><div class='timeline-scroller-time'></div>",
			scope: {
				timeline: "=",
				scale: "=",
				canvas: "="
			},
			link: function($scope, $el, $attributes) {			
				
				$scope.$watch("timeline", () => {
					_self.layout($scope, $el);
				}, true);
						
				$scope.$watch("time.time", () => {
					var left = $scope.timeline.time * $scope.localScale;
					$(".timeline-scroller-time", $el).css("left", left);
					_self.layout($scope, $el);
				});
				
				$scope.$watch("time.totalDuration", () => {
					var left = $scope.timeline.time * $scope.localScale;
					$(".timeline-scroller-time", $el).css("left", left);
					_self.layout($scope, $el);
				});
				
				$scope.$watch("scale", () => {
					_self.layout($scope, $el);
					_self.setScroll($scope, $el);
				});
				
				$(".timeline-scroller", $el).draggable({
					cursor: "ew-resize",
					axis: "x",
					containment: "parent",
					drag: (ev, ui) => {
						_self.setScroll($scope, $el, ui.position.left);
					}
				});
				
			}
		};

	}

	layout($scope, $el) {

		if($scope.timeline != null) {
			
			
			$scope.localScale = $el.width() / (($scope.timeline.duration || 30) + 1);
			var graticuleWidthInSeconds = $(".timeline-right-pane").width() / $scope.scale;
			var width = $scope.localScale * (graticuleWidthInSeconds - 1);
			
			var graticuleStartTime = -($(".timeline-right-pane-inner").position().left - 250)  / $scope.scale;
			var left = graticuleStartTime * $scope.localScale;
			
			$(".timeline-scroller").css({"left": left, "width": width});
			
								
			$(".timeline-anim").remove();
			$.each($scope.timeline.animations, function(ix, anim){
				
				var layer = $scope.canvas.layers.find(function(x) { return x.id == anim.layerId; });
				if("undefined" !== typeof layer) {
					var bkg = layer.builderColour || "#d06dd9";
				}
				else {
					var bkg = "#d06dd9";
				}
				
				var el = $("<div class='timeline-anim'></div>");
				el.css({left: anim.pos * $scope.localScale, width: anim.duration * $scope.localScale, "background-color": bkg });
				$el.append(el);
			});
			
		}

	}

	setScroll($scope, $el, scrollPos) {
		if("undefined" == typeof scrollPos) {
			var left = $(".timeline-scroller").position().left / $scope.localScale * $scope.scale * -1;
		}
		else {
			var left = scrollPos / $scope.localScale * $scope.scale * -1;
		}
		$(".timeline-right-pane-inner").css("left", left);
	}
	

}

angular.module('cpm').directive('reflowTimelineScroller', () => {
    'use strict';
    return new ReflowTimelineScroller();
});

